import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import { Box, Typography, Button, CircularProgress } from '@material-ui/core';
import api from '../utils/api';

const InvoicePaymentStatusPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const [status, setStatus] = useState('processing');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkInvoiceStatus = async () => {
      const searchParams = new URLSearchParams(location.search);
      const invoiceId = searchParams.get('invoice_id');
      const redirectStatus = searchParams.get('redirect_status');

      if (!invoiceId) {
        setStatus('error');
        setLoading(false);
        return;
      }

      try {
        const { invoice } = await api.user.getInvoice(invoiceId);

        if (invoice.status === 'paid') {
          setStatus('success');
        } else if (redirectStatus === 'succeeded') {
          setStatus('processing');
        } else {
          setStatus('processing');
        }
      } catch (error) {
        console.error('Error checking invoice status:', error);
        setStatus('error');
      } finally {
        setLoading(false);
      }
    };

    checkInvoiceStatus();
  }, [location]);

  const renderContent = () => {
    if (loading) {
      return (
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress />
          <Box mt={2}>
            <Typography variant="h6">{t('invoice:loading')}</Typography>
          </Box>
        </Box>
      );
    }

    if (status === 'success') {
      return (
        <Box textAlign="center">
          <Typography variant="h5" color="primary" gutterBottom>
            {t('invoice:payment_success')}
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => history.push('/frontofficev2/')}
            style={{ marginTop: '20px' }}
          >
            {t('invoice:return')}
          </Button>
        </Box>
      );
    }

    if (status === 'error') {
      return (
        <Box textAlign="center">
          <Typography variant="h5" color="error" gutterBottom>
            {t('invoice:loading_error')}
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => history.push('/frontofficev2/')}
            style={{ marginTop: '20px' }}
          >
            {t('invoice:return')}
          </Button>
        </Box>
      );
    }

    return (
      <Box textAlign="center">
        <Typography variant="h5" gutterBottom>
          {t('invoice:payment_processing_message')}
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => history.push('/frontofficev2/')}
          style={{ marginTop: '20px' }}
        >
          {t('invoice:return')}
        </Button>
      </Box>
    );
  };

  return (
    <Box
      p={3}
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="50vh"
    >
      {renderContent()}
    </Box>
  );
};

export default InvoicePaymentStatusPage;
